define('../app/fukit/model/product.model',['require','exports','module','./admin.base.model'],function(require, exports, module) {
  //prettier-ignore
  var AdminBaseModel = require('./admin.base.model');

  var ProductModel = AdminBaseModel.extend({
    radioRequests: { 'models ProductModel': '@constructor' },

    urlRoot: AdminBaseModel.prototype.baseUrlRoot + '/tenant/product/evisions',
  });

  module.exports = ProductModel;
});

